module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("题库")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("题目模板管理")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showAddTemplateList = true
      }
    }
  }, [_vm._v("添加模板")])], 1), _vm._v(" "), _c('List', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "",
      "params": _vm.queryParams,
      "reload": _vm.reload
    }
  }), _vm._v(" "), _c('CreateTemplateModal', {
    attrs: {
      "successCallback": _vm.search
    },
    model: {
      value: (_vm.showAddTemplateList),
      callback: function($$v) {
        _vm.showAddTemplateList = $$v
      },
      expression: "showAddTemplateList"
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "编辑题目模板"
    },
    model: {
      value: (_vm.showUpdateTemplateList),
      callback: function($$v) {
        _vm.showUpdateTemplateList = $$v
      },
      expression: "showUpdateTemplateList"
    }
  }, [_c('Form', {
    ref: "updateTemplateForm",
    staticClass: "form",
    attrs: {
      "rules": _vm.Rules,
      "model": _vm.updateTemplateParams
    }
  }, [_c('Row', [_c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "模板名称",
      "prop": "name"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入活动名称用于列表展示"
    },
    model: {
      value: (_vm.updateTemplateParams.name),
      callback: function($$v) {
        _vm.$set(_vm.updateTemplateParams, "name", $$v)
      },
      expression: "updateTemplateParams.name"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "题目大类",
      "prop": "type"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.updateTemplateParams.type),
      callback: function($$v) {
        _vm.$set(_vm.updateTemplateParams, "type", $$v)
      },
      expression: "updateTemplateParams.type"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "video"
    }
  }, [_vm._v("录音题")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "read"
    }
  }, [_vm._v("阅读理解")]), _vm._v(" "), _c('Option', {
    key: "3",
    attrs: {
      "value": "listen"
    }
  }, [_vm._v("听力题")])], 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "模板英文"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "请输入模板英文"
    },
    model: {
      value: (_vm.updateTemplateParams.english),
      callback: function($$v) {
        _vm.$set(_vm.updateTemplateParams, "english", $$v)
      },
      expression: "updateTemplateParams.english"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showUpdateTemplateList = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3120de8e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/question/TemplateList.vue
// module id = 1738
// module chunks = 8